export enum PromotionMessageType {
    Error = "Error",
    Info = "Info",
    Success = "Success",
    Warning = "Warning",
}
